import React from 'react';
const cuadernillos = [{
  icon: '⚡',
  title: 'TOMO 1 — 1° Año: Introducción a la Física y la Energía',
  desc: 'Método científico, magnitudes, medición y tipos de energía. ✅ Con SIMELA y NAP Argentina 2026.'
}, {
  icon: '🔬',
  title: 'TOMO 2 — 2° Año: Materia, Calor y Estados de la Naturaleza',
  desc: 'Densidad, estados, cambios, calor específico y transferencia térmica. ✅ Experimentos de cocina low cost.'
}, {
  icon: '🚗',
  title: 'TOMO 3 — 3° Año: Cinemática y Dinámica',
  desc: 'MRU, MRUV, caída libre y las 3 Leyes de Newton. ✅ Gráficos x-t y v-t listos para imprimir.'
}, {
  icon: '⚙️',
  title: 'TOMO 4 — 4° Año: Energía, Trabajo y Potencia',
  desc: 'Trabajo mecánico, Ec, Ep, conservación y rendimiento. ✅ Conexión con energía renovable Argentina 2026.'
}, {
  icon: '🌊',
  title: 'TOMO 5 — 5° Año: Ondas, Luz y Sonido',
  desc: 'Fenómenos ondulatorios, óptica geométrica y espectro electromagnético. ✅ Efecto Doppler, espejos y lentes resueltos.'
}, {
  icon: '⚡',
  title: 'TOMO 6 — 6° Año: Electricidad, Magnetismo y Física Moderna',
  desc: 'Circuitos, inducción, E=mc², cuántica y nuclear Argentina. ✅ CNEA, INVAP y tecnología 2026.'
}, {
  icon: '🏆',
  title: 'TOMO 7 — MASTER DE PROYECTOS Y FERIA DE CIENCIAS',
  desc: '15 proyectos completos paso a paso: Poleas, Hidráulica, Solar, Eólico, Motor Eléctrico, Cohete de Agua y Casa Sustentable. ✅ Guía de presentación al jurado incluida.'
}];
export function CuadernillosDetail() {
  return <section className="pt-8 pb-10 md:pt-10 md:pb-20 px-4 bg-white" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <div className="text-center mb-8 md:mb-16" data-id="element-68">
          <h2 className="text-4xl font-black text-brand-dark mb-4" data-id="element-69">
            Lo que recibís
          </h2>
          <div className="inline-block bg-brand-blue text-white font-bold px-6 py-2 rounded-lg text-xl" data-id="element-70">
            📘 SECUNDARIA — 7 Tomos
          </div>
          <p className="text-xl text-gray-600 mt-4 font-medium" data-id="element-71">
            Para docentes de Física de 1° a 6° año
          </p>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-72">
          {cuadernillos.map((c, i) => <div key={i} className="bg-white border-2 border-gray-100 p-6 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row gap-6 items-start" data-id="element-73">
              <div className="text-6xl flex-shrink-0" data-id="element-74">{c.icon}</div>
              <div data-id="element-75">
                <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-76">
                  {c.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-77">
                  {c.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}